/** Only explicit booking details justify the "Booked" label. Legacy
 * `confirmed` can also mean a manually added plan or a looked-up timetable. */
export function hasBookingDetails(item: {
  ref?: string | null;
  confirmRef?: string | null;
  bookingService?: string | null;
  documents?: readonly unknown[] | null;
  confirmed?: boolean;
  booked?: boolean;
}): boolean {
  if (typeof item.booked === 'boolean') return item.booked;
  return !!(item.ref?.trim() || item.confirmRef?.trim() || item.bookingService?.trim() || item.documents?.length);
}

/** Saved views show only populated booking/cost sections, regardless of confirmation. */
export function hasBookingMetadata(item: Parameters<typeof hasBookingDetails>[0] & { bookingNotes?: string; bookingDate?: string; time?: string }): boolean {
  return !!(item.booked || item.ref?.trim() || item.confirmRef?.trim() || item.bookingService?.trim()
    || item.documents?.length || item.bookingNotes?.trim() || item.bookingDate || item.time);
}

export function hasBookingContent(item: Parameters<typeof hasBookingDetails>[0] & {
  bookingNotes?: string; costAmount?: number; cost?: string; costKind?: string; paidStatus?: string;
  expenseLogId?: string; expenseLogIds?: string[];
  bookingDate?: string; time?: string;
}): boolean {
  return !!(hasBookingMetadata(item) || item.costAmount != null || item.cost?.trim()
    || (item.costKind && item.costKind !== 'unclear') || item.paidStatus
    || item.expenseLogId || item.expenseLogIds?.length);
}
